import { PropsWithChildren } from 'react'

import { ChatContext } from '@app/context'
import { useChatState } from '@app/hooks'

export const ChatProvider = ({ children }: PropsWithChildren) => {
  const value = useChatState()

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>
}
